import * as React from 'react';

import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';
import { GlobalClassKeys } from 'assets/jss/common-styles';
import MuiMuted from 'components/MuiExtras/Typography/MuiMuted';
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { WithTranslation, withTranslation } from 'react-i18next';

interface IState {
    showLeftChars: boolean;
}

interface IProps {
    value: string;
    maxLength: number;
    readOnly?: boolean;
    onChange?: (v: string) => void;
    onPressEnter?: (v: string) => void;
    onBlur?: () => void;
}

type Props = IProps & WithTranslation & Omit<StandardTextFieldProps, "value" | "onFocus" | "onBlur" | "onChange" | "onKeyDown" | "inputProps" | "InputProps" | "inputRef" | "classes">;

class TextFieldCounter extends React.PureComponent<Props, IState> {

    private refText: HTMLInputElement;

    static defaultProps = {
        readOnly: false
    };

    constructor(props: Props) {
        super(props);
        this.state = { showLeftChars: false };
    }

    private changeValue(e: React.ChangeEvent) {
        const text = (e as React.ChangeEvent<HTMLTextAreaElement>).target.value;
        if (this.props.onChange) this.props.onChange(text);
    }

    private keyDown(e: React.KeyboardEvent) {
        if (e.keyCode == 13 && this.props.onPressEnter != null) {
            e.preventDefault();
            this.props.onPressEnter(this.refText.value);
        }
    }

    componentDidMount() {
        if (this.props.autoFocus && this.refText) setTimeout(() => { this.refText.focus && this.refText.focus(); }, 50);
    }

    render() {
        const { value, maxLength, onChange, onPressEnter, t, i18n, tReady, ...rest } = this.props;
        return (
            <>
                <TextField
                    {...rest}
                    classes={null}
                    inputProps={{ maxLength: this.props.maxLength }}
                    InputProps={{ readOnly: this.props.readOnly }}
                    inputRef={(ref) => this.refText = ref}
                    onKeyDown={(e) => this.keyDown(e)}
                    onFocus={() => { this.setState({ showLeftChars: true }); }}
                    onBlur={() => { this.setState({ showLeftChars: false }, () => this.props.onBlur && this.props.onBlur()); }}
                    onChange={(e) => this.changeValue(e)}
                    value={this.props.value}
                />

                {

                    <div
                        className={
                            this.props.value == null || this.props.value.length == 0 || !this.state.showLeftChars
                                ? GlobalClassKeys.hideElement
                                : null
                        }
                    >
                        {
                            (this.props.value != null && (this.props.maxLength - this.props.value.length) >= 0) &&
                            <MuiMuted>
                                <small>
                                    <span>{this.props.maxLength - this.props.value.length} {this.props.t("Common.Literals.CharsRemaining")}</span>
                                </small>
                            </MuiMuted>
                        }
                        {
                            (this.props.value != null && (this.props.maxLength - this.props.value.length) < 0) &&
                            <MuiColor variant="error">
                                <small>
                                    <span>{this.props.value.length - this.props.maxLength} {this.props.t("Common.Literals.CharsAboveLimit")}</span>
                                </small>
                            </MuiColor>
                        }
                    </div>
                }
            </>
        );
    }
}

export default withTranslation()(TextFieldCounter);